import React from 'react'
import {
  Route,
  Redirect,
} from 'react-router-dom'

const ROLES = {
  PRINCIPAL_ROLE: 'principal',
  PARENT_ROLE: {
    label: 'Parent',
    path: '/parent',
  },
  TEACHER_ROLE: 'teacher',
  ADMIN_ROLE: 'admin',
}

export const MainRoute = ({ user, component, ...rest }) => {
  const Component = component
  const { user_type } = user
  if (user_type === ROLES.PARENT_ROLE.label) {
    return (
      <Route
        {...rest}
        render={props => (
          <Redirect to={{ pathname: ROLES.PARENT_ROLE.path, state: { from: props.location } }} />
        )}
      />)
  }
  return <Route {...rest} render={props => <Component {...props} />} />
}

export const ParentRoute = ({ user, component, ...rest }) => {
  const Component = component
  const { user_type } = user
  if (user_type !== ROLES.PARENT_ROLE.label) {
    return (
      <Route
        {...rest}
        render={props => (
          <Redirect to={{ pathname: '/', state: { from: props.location } }} />
        )}
      />)
  }
  return <Route {...rest} render={props => <Component {...props} />} />
}

export default {
  MainRoute,
  ParentRoute,
}



// WEBPACK FOOTER //
// ./src/Components/CustomRoutes/index.jsx